<template>
  <div class="profile-wrapper" style="
      min-height: calc(100vh - 60px);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    ">
    <div class="profile-header has-text-centered">
      <h3 class="title is-4 is-narrow" style="font-weight: 600; font-size: 30px">
        {{ $t("e.welcome") }}
      </h3>
      <p class="light-text">
        {{ $t("e.description") }}
      </p>
    </div>

    <div class="profile-body" style="padding-bottom: 5px">
      <div class="settings-section">
        <div class="settings-box settings-box2 shadow-sm" style="border: none" v-for="i in $store.state.categories"
          @click="
            category = i;
            visible = true;
          ">
          <div class="icon-wrap">
            <img :src="'/static/img/' + i.icon" alt="" />
          </div>
          <span style="
              text-transform: none;
              word-break: break-word;
              font-family: Poppins;
              font-weight: bold;
            ">{{ $t("cats." + i.title) }}</span>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="visible" :title="$t('cats.' + category.title)">
      <div class="container">
        <div class="row">
          <div class="col-md-3">
            <img style="width: 80%" :src="'/static/img/' + category.icon" alt="" />
          </div>
          <div class="col-md-9">
            <p v-html="category['description_' + $i18n.locale]"></p>
          </div>
        </div>
        <div class="row mt-5">
          <div v-if="category.title == 'Okuma & Anlama'" class="col-md-4 mb-5 module" style="cursor: pointer">
            <div style="
                box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
                background: white;
                padding: 10px 15px;
                border-radius: 7px;
              ">
              <h3 @click="
                  $router.push({
                    name: 'ExerciseDetail',
                    params: { type: module.slug },
                  })
                " style="font-size: 22px; margin-bottom: 5px" class="d-flex flex-row">
                <span style="display: flex; flex: 1; flex-direction: row">
                  {{
                  $store.state.user.level == "İlkokul" ||
                  $store.state.user.level == "Ortaokul" ||
                  $store.state.user.level == "Lise" ||
                  $store.state.user.level == "Yetişkin" ||
                  $store.state.user.level == 'İleri Seviye Yetişkin'
                  ? "Okuma Hızı Testi"
                  : "Soru Okuma Hızı Testi"
                  }}
                </span>

                <span><i class="fas fa-arrow-right"></i></span>
              </h3>
              <img @click="
                  $router.push({
                    name:
                      $store.state.user.level == 'İlkokul' ||
                      $store.state.user.level == 'Ortaokul' ||
                      $store.state.user.level == 'Lise' ||
                      $store.state.user.level == 'Yetişkin'
                        ? 'SpeedTest'
                        : 'SinavSpeedTest',
                  })
                " :src="'/static/img/moduller/gruplama.png'" style="width: 100%" alt="" />
              <VueReadMoreSmooth :key="-1" text="Devamını Oku" text-less="Gizle">
                <p>
                  Bu bölüm okuma hızınızı ve anlama oranınızı ölçme amacıyla
                  oluşturulmuştur. Hızlı okuma testi gelişim seviyenize göre
                  (ilk, orta, lise ve yetişkin) farklı metinler içermektedir.
                  İstediğiniz metini seçerek okuma hızınızı ölçebilirsiniz.
                  Okuma hızınız metin konusuna ve içeriğine bağlı olarak
                  değişiklik gösterebilir. Okuma hızınızı ölçmek için "Başlat"
                  butonuna tıklayın. Ekrana çıkan metini okumaya başlayın ve
                  okumanız bittiğinde "Bitir" butonuna tıklayarak sonucunuzu
                  görüntüleyin.
                </p>
              </VueReadMoreSmooth>
            </div>
          </div>
          <div v-if="
              category.title == 'Okuma & Anlama' &&
              $store.state.user.level == 'LGS'
            " class="col-md-4 mb-5 module" style="cursor: pointer">
            <div style="
                box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
                background: white;
                padding: 10px 15px;
                border-radius: 7px;
              ">
              <h3 @click="
                  $router.push({
                    name: 'ExerciseDetail',
                    params: { type: module.slug },
                  })
                " style="font-size: 22px; margin-bottom: 5px" class="d-flex flex-row">
                <span style="display: flex; flex: 1; flex-direction: row">
                  Okuma Hızı Testi
                </span>

                <span><i class="fas fa-arrow-right"></i></span>
              </h3>
              <img @click="
                  $router.push({
                    name: 'SpeedTest',
                  })
                " :src="'/static/img/moduller/gruplama.png'" style="width: 100%" alt="" />
              <VueReadMoreSmooth :key="-1" text="Devamını Oku" text-less="Gizle">
                <p>
                  Bu bölüm okuma hızınızı ve anlama oranınızı ölçme amacıyla
                  oluşturulmuştur. Hızlı okuma testi gelişim seviyenize göre
                  (ilk, orta, lise ve yetişkin) farklı metinler içermektedir.
                  İstediğiniz metini seçerek okuma hızınızı ölçebilirsiniz.
                  Okuma hızınız metin konusuna ve içeriğine bağlı olarak
                  değişiklik gösterebilir. Okuma hızınızı ölçmek için "Başlat"
                  butonuna tıklayın. Ekrana çıkan metini okumaya başlayın ve
                  okumanız bittiğinde "Bitir" butonuna tıklayarak sonucunuzu
                  görüntüleyin.
                </p>
              </VueReadMoreSmooth>
            </div>
          </div>
          <div class="col-md-4 mb-5 module" style="cursor: pointer" v-for="module in $store.state.modules.filter(
              (k) => k.category == category.title && hasAccess(k.slug)
            )">
            <div style="
                box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
                background: white;
                padding: 10px 15px;
                border-radius: 7px;
              ">
              <h3 @click="
                  $router.push({
                    name: 'ExerciseDetail',
                    params: { type: module.slug },
                  })
                " style="font-size: 22px; margin-bottom: 5px" class="d-flex flex-row">
                <span style="
                    display: flex;
                    flex: 1;
                    flex-direction: row;
                    word-break: break-word;
                  ">
                  {{ $t("modules." + module.title) }}
                </span>

                <span><i class="fas fa-arrow-right"></i></span>
              </h3>
              <img @click="
                  $router.push({
                    name: 'ExerciseDetail',
                    params: { type: module.slug },
                  })
                " :src="'/static/img/moduller/' + module.icon" style="width: 100%" alt="" />
              <VueReadMoreSmooth :key="module.module_id" text="Devamını Oku" text-less="Gizle">
                <p v-html="module['description_' + $i18n.locale]"></p>
              </VueReadMoreSmooth>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueReadMoreSmooth from "vue-read-more-smooth";
export default {
  name: "Exercises",
  components: { VueReadMoreSmooth },
  data() {
    return {
      activeTab: null,
      visible: false,
      category: {},
      az_modules: [
        "es-anlamlilar",
        "speed-test",
        "kelime-avi",
        "duzelt-bakalim",
      ],
    };
  },
  methods: {
    hasAccess(slug) {
      var module = this.$store.state.modules.find((k) => k.slug == slug);
      var a = module.levels.some(
        (k) => k.level == this.$store.state.user.level
      );

      if (this.$i18n.locale != "az") return a;

      if (this.az_modules.some((x) => x == slug)) return false;

      return a;
    },
  },
};
</script>

<style lang="less">
.settings-box {
  width: calc(25% - 16px) !important;

  span {
    font-size: 14px !important;
  }
}

.settings-box2 {
  width: calc(33.333% - 16px) !important;
  min-height: 100px;

  span {
    font-size: 14px !important;
  }

  .icon-wrap {
    height: unset !important;
    margin-bottom: 20px !important;
  }
}

.el-dialog__body {
  p {
    color: #333;
    word-break: break-word;
    font-size: 15px;
  }

  .module p {
    font-size: 14px;
    width: 100%;
    line-height: 21px;
  }
}

.el-dialog {
  width: 80%;
}

.el-dialog__title {
  line-height: 24px;
  font-size: 28px;
  color: #303133;
  text-align: center;
  display: block;
}

.read-more-button {
  cursor: pointer;
  display: block;
  position: relative;
  border-top: 1px solid #dbdbdb;
  height: 0.1em;
  margin: 10px auto !important;
  width: 95%;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/Exercises.vue